import { useState, useEffect, useCallback } from 'react';
import { api } from '../services/api';
import type { HomeRecommendationsResponse } from '../types/recommendation.types';

interface UseHomeActivitiesResult {
  data: HomeRecommendationsResponse | null;
  isLoading: boolean;
  error: string | null;
  refetch: () => void;
}

export function useHomeActivities(timezone: string): UseHomeActivitiesResult {
  const [data, setData] = useState<HomeRecommendationsResponse | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchActivities = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(null);

      const result = await api.getHomeActivities(timezone);

      setData(result);
      setIsLoading(false);
    } catch (err: unknown) {
      console.error('[useHomeActivities] Fetch error:', err);
      setError(err instanceof Error ? err.message : 'Failed to fetch home activities');
      setIsLoading(false);
    }
  }, [timezone]);

  useEffect(() => {
    fetchActivities();
  }, [fetchActivities]);

  return {
    data,
    isLoading,
    error,
    refetch: fetchActivities,
  };
}
